export function getDocumentType(value: string): {
  type: string;
  label: string;
} {
  const mapper: Record<string, { values: string[]; label: string }> = {
    boleta: {
      values: ['BOLETA', 'BLT'],
      label: 'Boleta de pago',
    },
    factura: {
      values: ['FACTURA', 'FCT', 'TFC'],
      label: 'Factura',
    },
    'nota-credito': {
      values: ['NCR'],
      label: 'Nota de crédito',
    },
  };

  for (const [type, { values, label }] of Object.entries(mapper)) {
    if (values.includes(value)) {
      return { type: type as string, label };
    }
  }
  return {
    label: 'Desconocido',
    type: 'desconocido' as any,
  };
}
